import React, { useRef } from "react";
import Slider from "react-slick";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { whatTheySayContent } from "../../content/home/whatTheySayContent";

const IoIosArrowBackComponent = IoIosArrowBack as any;
const IoIosArrowForwardComponent = IoIosArrowForward as any;

const WhatTheySay: React.FC = () => {
    const sliderRef = useRef<any>(null);

    const { title, sliderSettings, testimonials } = whatTheySayContent;

    return (
        <section className="bg-[#D4A752] py-16 text-center relative text-[#1D1D1D]">

            <IoIosArrowBackComponent
                className="absolute left-20 top-1/2 -translate-y-1/2 text-2xl cursor-pointer z-10"
                onClick={() => sliderRef.current?.slickPrev()}
            />
            <IoIosArrowForwardComponent
                className="absolute right-20 top-1/2 -translate-y-1/2 text-2xl cursor-pointer z-10"
                onClick={() => sliderRef.current?.slickNext()}
            />

            <div className="max-w-5xl mx-auto px-4">
                <h2
                    className="text-[40px] font-normal mb-8"
                    style={{ fontFamily: "Roboto Serif" }}
                >
                    {title}
                </h2>

                <Slider ref={sliderRef} {...sliderSettings}>
                    {testimonials.map((item, index) => (
                        <div key={index}>
                            <blockquote className="text-[24px] leading-relaxed mb-6 text-[#353535]">
                                “{item.quote}”
                            </blockquote>

                            <p
                                className="text-[24px] text-[#353535]"
                                dir="rtl"
                                lang="ar"
                            >
                                "{item.translation}"
                            </p>
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
};

export default WhatTheySay;